import customComponents from '@/components/formcomponents/index.js'
import formCreate from '@form-create/element-ui'
import VXETable from 'vxe-table'
import phoneGrid from '@_system/components/base/phone/grid/grid.vue'
import tableformbutton from '@_system/components/formcomponents/common/tableformbutton/index.vue'


import department from '@_system/components/formcomponents/common/select/department/select.vue'
import phonedepartment from '@_system/components/formcomponents/phone/select/department/select.vue'
import postjob from '@_system/components/formcomponents/common/select/postjob/select.vue'
import joblevel from '@_system/components/formcomponents/common/select/joblevel/select.vue'
import group from '@_system/components/formcomponents/common/select/group/select.vue'
import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
import customemun from '@_system/components/formcomponents/common/select/customemun/select.vue'


import select from '@_system/components/formcomponents/common/select/select/select.vue'
import module from '@_system/components/formcomponents/common/select/module/select.vue'
import report from '@_system/components/formcomponents/common/select/report/select.vue'
import controll from '@_system/components/formcomponents/common/select/controll/select.vue'
import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
import vJsoneditor from 'v-jsoneditor'
import flowGraph from '@_system/components/formcomponents/common/graph/flow/index.vue'
import relationGraph from '@_system/components/formcomponents/common/graph/relation/index.vue'
import table from '@_system/components/formcomponents/common/table/index.vue'
import tableBatchmodify from '@_system/components/formcomponents/common/table/tools/batchmodify.vue'
import box from '@_system/components/formcomponents/common/box/index.vue'


import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
import calendar from '@_system/components/formcomponents/common/calendar/index.vue'
import button from '@_system/components/formcomponents/common/button/index.vue'
import input from '@_system/components/formcomponents/common/input/index.vue'
import textarea from '@_system/components/formcomponents/common/textarea/index.vue'
import inputNumber from '@_system/components/formcomponents/common/inputNumber/index.vue'
import inputButton from '@_system/components/formcomponents/common/inputButton/index.vue'
import switchs from '@_system/components/formcomponents/common/switchs/index.vue'
import slider from '@_system/components/formcomponents/common/slider/index.vue'
import popover from '@_system/components/formcomponents/common/popover/index.vue'
import quote from '@_system/components/formcomponents/common/quote/index.vue'
import flowstatus from '@_system/components/formcomponents/common/flowstatus/index.vue'
import auditorstaffid from '@_system/components/formcomponents/common/auditorstaffid/index.vue'
import upload from '@_system/components/formcomponents/common/upload/index.vue'
import auth from '@_system/components/formcomponents/common/auth/index.vue'

import phoneselect from '@_system/components/formcomponents/phone/select/select/select.vue'
import phonepostjob from '@_system/components/formcomponents/phone/select/postjob/select.vue'
import phonequote from '@_system/components/formcomponents/phone/quote/index.vue'
import phonetable from '@_system/components/formcomponents/phone/table/index.vue'
import phonebox from '@_system/components/formcomponents/phone/box/index.vue'
import phonepopover from '@_system/components/formcomponents/phone/popover/index.vue'
import phonestaff from '@_system/components/formcomponents/phone/select/staff/select.vue'
import phoneinput from '@_system/components/formcomponents/phone/input/index.vue'
import phonetextarea from '@_system/components/formcomponents/phone/textarea/index.vue'
import phoneemun from '@_system/components/formcomponents/phone/select/emun/select.vue'
import phoneinputNumber from '@_system/components/formcomponents/phone/inputNumber/index.vue'
import phonedatePicker from '@_system/components/formcomponents/phone/datePicker/index.vue'
import phonecalendar from '@_system/components/formcomponents/phone/calendar/index.vue'
import phoneinputButton from '@_system/components/formcomponents/phone/inputButton/index.vue'
import phoneslider from '@_system/components/formcomponents/phone/slider/index.vue'
import phoneswitchs from '@_system/components/formcomponents/phone/switchs/index.vue'
import phonebuttondropdowns from '@_system/components/formcomponents/phone/buttondropdowns/index.vue'
import phoneupload from '@_system/components/formcomponents/phone/upload/index.vue'
import phoneflowstatus from '@_system/components/formcomponents/phone/flowstatus/index.vue'
import phoneauditorstaffid from '@_system/components/formcomponents/phone/auditorstaffid/index.vue'

import {
	codemirror
} from 'vue-codemirror'
import 'codemirror/mode/php/php.js'
import 'codemirror/theme/cobalt.css'
import 'codemirror/addon/selection/active-line.js'

const components = [
	...customComponents.components,
	{
		name: 'department',
		component: department,
		componentphone: phonedepartment,
		onlyEl: false
	}, {
		name: 'postjob',
		component: postjob,
		componentphone: phonepostjob,
		onlyEl: false
	}, {
		name: 'tableformbutton',
		component: tableformbutton,
		onlyEl: false
	}, {
		name: 'joblevel',
		component: joblevel,
		onlyEl: false
	}, {
		name: 'group',
		component: group,
		onlyEl: false
	}, {
		name: 'staff',
		component: staff,
		componentphone: phonestaff,
		onlyEl: false
	},{
		name: 'customemun',
		component: customemun,
		onlyEl: false
	}, {
		name: 'select',
		component: select,
		componentphone: phoneselect,
		onlyEl: false
	}, {
		name: 'module',
		component: module,
		onlyEl: false
	}, {
		name: 'report',
		component: report,
		onlyEl: false
	}, {
		name: 'controll',
		component: controll,
		onlyEl: false
	}, {
		name: 'emun',
		component: emun,
		componentphone: phoneemun,
		onlyEl: false
	}, {
		name: 'vjsoneditor',
		component: vJsoneditor,
		onlyEl: true
	}, {
		name: 'codemirror',
		component: codemirror,
		onlyEl: true
	}, {
		name: 'flowGraph',
		component: flowGraph,
		onlyEl: true
	}, {
		name: 'relationGraph',
		component: relationGraph,
		onlyEl: true
	}, {
		name: 'table',
		component: table,
		componentphone: phonetable,
		onlyEl: true
	}, {
		name: 'box',
		component: box,
		componentphone: phonebox,
		onlyEl: true
	}, {
		name: 'input',
		component: input,
		componentphone: phoneinput,
		onlyEl: false
	}, {
		name: 'textarea',
		component: textarea,
		componentphone: phonetextarea,
		onlyEl: true
	}, {
		name: 'button',
		component: button,
		onlyEl: true
	}, {
		name: 'inputNumber',
		component: inputNumber,
		componentphone: phoneinputNumber,
		onlyEl: false
	}, {
		name: 'popover',
		component: popover,
		componentphone: phonepopover,
		onlyEl: true
	}, {
		name: 'datePicker',
		component: datePicker,
		componentphone: phonedatePicker,
		onlyEl: false
	}, {
		name: 'calendar',
		component: calendar,
		componentphone: phonecalendar,
		onlyEl: false
	}, {
		name: 'inputButton',
		component: inputButton,
		componentphone: phoneinputButton,
		onlyEl: false
	}, {
		name: 'switchs',
		component: switchs,
		componentphone: phoneswitchs,
		onlyEl: false
	}, {
		name: 'slider',
		component: slider,
		componentphone: phoneslider,
		onlyEl: true
	}, {
		name: 'quote',
		componentphone: phonequote,
		component: quote,
		onlyEl: false
	}, {
		name: 'flowstatus',
		componentphone: phoneflowstatus,
		component: flowstatus,
		onlyEl: false
	}, {
		name: 'auditorstaffid',
		componentphone: phoneauditorstaffid,
		component: auditorstaffid,
		onlyEl: false
	}, {
		name: 'upload',
		component: upload,
		componentphone: phoneupload,
		onlyEl: false
	}, {
		name: 'auth',
		component: auth,
		onlyEl: false
	}
	
	
]
components.forEach((item) => {
	if (window.systemMethods.device() != 'pc' && item.componentphone) {
		formCreate.component('$' + item.name, item.componentphone)
	} else {
		formCreate.component('$' + item.name, item.component)
	}
	if (!item.onlyEl) {
		VXETable.renderer.add('$' + item.name, {			
			renderItemContent(h, renderOpts, params) {
				let {
					data,
					property
				} = params
				let props = renderOpts.props || {}
				//props.table = params.$table
				props.tableFormInfo = params
				let divClass = 'type--text size--' + props.size + ' is--controls'
				return [
					// <div class = {divClass} style="display:block;"> <item.component v-model = {data[property]} { ...{ props } } /></div >
					<div class = {divClass} style="display:block;"> <item.component v-model = {data[property]} { ...{ props } } /></div >
				]
			},
			renderEdit(h, renderOpts, params) {
				//console.log(params)
				let {
					row,
					column
				} = params
				const {
					events
				} = renderOpts
				let props = renderOpts.props || {}
				props.table = params.$table
				props.column = column
				props.row = row
				// props.value = row[column.field]
				props.renderOpts = renderOpts
				
				return [<item.component v-model = {row[column.property]} renderEdit= {true} { ...{ props } }  onChange={				
							(e) => {
								if(events){
									events.change?events.change(params,e):null
								}								
							}
						} onBlur={
							() => {
								if(events){
									events.blur?events.blur(params):null
								}
								
							}
						}  onInputButtonclick={
							(e) => {
								if(events){
									events.inputButtonclick(params,e)
								}
								
							}
						}/>]
			},
			// renderCell(h, renderOpts, { row, column} ) {
			// 	return [<span>{ row[column.property] }</span>]
			// },
			renderCell(h, renderOpts, params) {
				let {
					row,
					column
				} = params
				const {
					events
				} = renderOpts
				let props = renderOpts.props || {}
				props.table = params.$table
				props.column = column
				props.row = row
				// props.value = row[column.field]
				props.renderOpts = renderOpts
				return [
					<item.component v-model = {row[column.property]} { ...{ props }}  renderCell= {true}  onChange={				
							(e) => {
								//console.log(item.name)
								if(item.name === 'upload' || item.name === 'phoneupload' || item.name === 'switchs'){
									if(events){
										events.change?events.change(params,e):null
									}	
								}							
							}
						}  onInputButtonclick={
						(e) => {
							events.inputButtonclick(params,e)
						}
					}/>
				]
			},
			renderFilter (h, renderOpts, params) {
				return <item.component v-model={params.column.filters[0].data} onChange={
					(e)=>{
						params.column.filters[0].data = e
						params.$panel.changeOption(false,!!e, params.column.filters[0])
					}
				}  />
			},
			// 重置数据方法
			filterResetMethod ({ options }) {
					options.forEach((option) => {
					option.data = ''
				})
			},
			// 重置筛选复原方法（当未点击确认时，该选项将被恢复为默认值）
			filterRecoverMethod ({ option }) {
				option.data = ''
			},
			// 筛选方法
			filterMethod ({ option, row, column }) {

				const { data } = option
				const cellValue = row[column.field]
				if (cellValue) {
					return cellValue.indexOf(data) > -1
				}
				return false
			}
			
			
			
		})

	}
})




VXETable.renderer.add('$box', {
	renderToolbarButton(h, renderOpts, params) {
		const {
			events,
			props
		} = renderOpts
		props.store = params.$grid.$parent.store

		return <box { ...{ props } } onSubmit={
			(e) => {
				events.add(e)
			}
		} onBoxdataload={
			(e) => {
				events.boxdataload(e)
			}
		} onBoxdatapenetrate={
			(e) => {
				events.boxdatapenetrate(e)
			}
		}></box>
	}
})
VXETable.renderer.add('$batchmodify', {
	renderToolbarTool(h, renderOpts, params) {
		const {
			$grid
		} = params
		const {
			events,
			props
		} = renderOpts
		props.table = $grid
		return <tableBatchmodify { ...{ props } } onSubmit={
			(e) => {
				events.submit(e)
			}
		}></tableBatchmodify>
	}
})
VXETable.renderer.add('$operateButton', {
	renderDefault(h, renderOpts, params) {
		let {
			row
		} = params
		let {
			bind,
			buttons
		} = renderOpts
		let doms = []
		let dropdowns = []
		buttons.forEach((item) => {
			let buff = !!item.inrow
			if (buff) {
				doms.push(<vxe-button onClick={ () => {bind.operateButtonClickEvent({code:item.code,data:row})} } status={item.status}  type="text" content={item.content}>
				</vxe-button>)
			} else {
				dropdowns.push(<vxe-button style="width:auto;padding:0,10px"  onClick={ () => {bind.operateButtonClickEvent({code:item.code,data:row})} } type="text" content={item.content}>
				</vxe-button>)
			}
		})
		if (dropdowns.length != 0) {
			doms.push(
				<vxe-button type="text" transfer><template slot="default">更多</template><template slot="dropdowns">{dropdowns}</template></vxe-button>
			)

		}
		
		return doms
	}
})
phoneGrid.renderer.add('$operateButton', {
	renderDefault(h, renderOpts, params) {
		let {
			row
		} = params
		let {
			bind,
			buttons
		} = renderOpts
		let doms = []
		let dropdowns = []
		buttons.forEach((item) => {
			let buff = !!item.inrow
			if (buff) {
				doms.push(<van-button size="small" onClick={ () => {bind.operateButtonClickEvent({code:item.code,data:row})} } type={item.status} >{item.content}
				</van-button>)
			} else {
				dropdowns.push({
					name: item.content,
					code: item.code
				})
				// dropdowns.push(<van-button icon={item.icon}  onClick={ () => {bind.operateButtonClickEvent({code:item.code,data:row})} } type="text" content={item.content}>
				// </van-button>)
			}
		})
		if (dropdowns.length != 0) {
			doms.push(
				<phonebuttondropdowns data={row} dropdowns={dropdowns} onSelect={(e)=>{bind.operateButtonClickEvent(e)}} />
			)

		}
		return doms
	}
})
phoneGrid.renderer.add('$box', {
	renderToolbarButton(h, renderOpts, params) {
		const {
			events,
			props
		} = renderOpts
	
		props.store = params.$grid.store
		return <phonebox { ...{ props } } onSubmit={
			(e) => {
				events.add(e)
			}
		} onBoxdataload={
			(e) => {
				events.boxdataload(e)
			}
		} onHide={
			() => {
				params.$table.hideAction()
			}
		}></phonebox>
	}
})
